<div class="form-horizontal" [formGroup]="plantingInstructions">
  
    <div class="form-group" [class.has-error]="numberToStartControl.invalid">
      <label class="col-sm-3 control-label">Number of Seeds to Start</label>
      <span class="col-sm-9">
        <div class="form-control-static">{{ numberToStart }}</div>
        <div class="alert alert-danger"
          *ngIf="numberToStartControl.errors?.min">
          Number of Seeds to Start must be at least {{ numberToStartControl.errors?.min.min }}.
        </div>  
      </span>
    </div>

    <div class="form-group" *ngIf="isWheatRequest" [class.has-error]="numberOfSeedsPerCellControl.invalid">
      <label class="col-sm-3 control-label">Number of Seeds per Cell</label>
      <span class="col-sm-9">
        <div class="form-control-static">{{ numberOfSeedsPerCell }}</div>
        <div class="alert alert-danger"
          *ngIf="numberOfSeedsPerCellControl.errors"
        >
          Number of Seeds per Cell must be between 1 - 3.
        </div>
      </span>
    </div>
  
    <div class="form-group" *ngIf="numberToPotsControl.enabled" 
        [class.has-error]="numberToPotsControl.invalid || plantingInstructions.errors?.numberToPots">
      <label class="col-sm-3 control-label">Number of Plants to Pots</label>
      <span class="col-sm-9">
        <input type="number" class="form-control" formControlName="numberToPots" appIntegerValueAccessor />
  
        <div class="alert alert-danger"
          *ngIf="numberToPotsControl.errors?.min">
          Number of Plants to Pots must be at least {{ numberToPotsControl.errors?.min.min }}.
        </div>
        
        <div class="alert alert-danger"
          *ngIf="plantingInstructions.errors?.numberToPots">
          The maximum value for Number of Plants to Pots is {{ plantingInstructions.errors?.numberToPots.max }}.
        </div>  
      </span>
    </div>
  
    <div class="form-group" *ngIf="numberToHarvestControl.enabled" 
        [class.has-error]="numberToHarvestControl.invalid || plantingInstructions.errors?.numberToHarvest">
      <label class="col-sm-3 control-label">Number of Plants to Harvest</label>
      <span class="col-sm-9">
  
        <input type="number" class="form-control" formControlName="numberToHarvest" appIntegerValueAccessor />
  
        <div class="alert alert-danger"
          *ngIf="numberToHarvestControl.errors?.min">
          Number of Plants to Harvest must be at least {{ numberToHarvestControl.errors?.min.min }}.
        </div>
        
        <div class="alert alert-danger"
          *ngIf="plantingInstructions.errors?.numberToHarvest">
          The maximum value for Number of Plants to Harvest is {{ plantingInstructions.errors.numberToHarvest.max }}.
        </div>
  
        <div class="alert alert-danger"
          *ngIf="numberToHarvestControl.errors?.integer">
          Number of Plants to Harvest must be a whole number.
        </div>
      </span>
    </div>
  
  </div>


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/experiment-design/planting-instructions/planting-instructions-form/planting-instructions-form.component.html